export default {"src":"/minerva/_next/static/media/luxembourg-logo.e90601e0.svg","height":56,"width":93,"blurWidth":0,"blurHeight":0};